import CRUDService from "./CRUDService";

class TagService extends CRUDService {
  constructor() {
    super('tags')
  }
}

export default new TagService()
